<template>
  <div>
    <div>
      <!-- <breadcrumb :routerList="[{to:'/xuqiu/Lmanagement',title:'协同管理'},{title:'新增协同问题'}]" /> -->
      <div class="h-content">
        <div class="h-row h-mrt0">
          <div class="h-rowIn">
            <div class="h-rowBox">
              <div class="h-rowCon">
                <div class="h-pieceIn2">
                  <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">
                                        新增资源需求
                                    </div> -->
                  <div
                    class="h-pieceTitle2"
                    style="margin-bottom: 0.3rem;"
                  >
                    <h1>反馈问题</h1>
                  </div>
                  <div
                    class="h-pieceCon2"
                    style="padding:0"
                  >
                    <div class="h-formLine weekplandetail34">
                      <el-form
                        :model="zy"
                        label-position="right"
                        ref="zy"
                        :inline="true"
                        :rules="rules"
                        class="demo-ruleForm h-formbLine h-formbLine1"
                        :disabled="taskstatus==1"
                      >
                        <el-form-item
                          label="客户类型"
                          class="h-elformWrap-2"
                          prop="euType"
                        >
                          <el-input
                            value="经销商"
                            :disabled="true"
                          ></el-input>
                        </el-form-item>
                        <el-form-item
                          label="客户名称"
                          class="h-elformWrap-2"
                          prop="euName"
                          :clearable="true"
                        >
                          <el-input
                            v-model="zy.euName"
                            :v="zy.euName"
                            :disabled="true"
                          ></el-input>
                        </el-form-item>
                        <el-form-item
                          label="区域"
                          class="h-elformWrap-2"
                          prop="areaCode"
                        >
                          <brselect
                            category="YLRegion"
                            v-model="zy.areaCode"
                            :v="zy.areaCode"
                          ></brselect>
                        </el-form-item>
                        <el-form-item
                          label="链群"
                          class="h-elformWrap-2"
                          prop="lianqun"
                        >
                          <brselect
                            category="gh_lianqun"
                            v-model="zy.lianqun"
                            :v="zy.lianqun"
                          ></brselect>
                        </el-form-item>
                        <el-form-item
                          label="问题分类"
                          class="h-elformWrap-2"
                          prop="problemType"
                        >
                          <brselect
                            category="xtwt_type"
                            v-model="zy.problemType"
                            :v="zy.problemType"
                          ></brselect>
                        </el-form-item>
                        <el-form-item
                          label="要求到位时间"
                          class="h-elformWrap-2"
                          prop="endDate"
                        >
                          <el-date-picker
                            v-model="zy.endDate"
                            :picker-options="pickerOptions"
                            type="date"
                            value-format="yyyy-MM-dd"
                            @change="getDate"
                            placeholder="选择日期"
                          >
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item
                          label="反馈问题"
                          class="h-elformWrap-1"
                          prop="dailyQuestion"
                        >
                          <el-input
                            v-model="zy.dailyQuestion"
                            placeholder="请输入"
                          ></el-input>
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                  <div
                    class="h-table h-mrt30 ljjtablepaddingsxuqiu"
                    style="margin: 20px 20px 0 10px;"
                  >
                    <div class="h-pieceTitle2 message">
                      <h1 class="h1">承接部门及答复人</h1>
                    </div>
                    <el-table
                      ref="multipleTable"
                      :data="deptList"
                      :border="true"
                      stripe
                      style="width: 100%"
                    >
                      <el-table-column
                        type="index"
                        width="40"
                        label="#"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="jobGroup"
                        label="承接部门"
                        width="300"
                      >
                        <template scope="scope">
                          <el-select
                            v-if="taskstatus==0"
                            class="h-tableInput"
                            v-model="scope.row.jobGroup"
                            :v="scope.row.jobGroup"
                            placeholder="请选择"
                            style="width: 100%"
                            @change="selectUser(scope.row)"
                          >
                            <el-option
                              v-for="(item) in JobGroup"
                              :key="item.id"
                              :label="item.jobGroup"
                              :value="item.jobGroup"
                            >
                            </el-option>
                          </el-select>
                          <span
                            style="color: #2785e7;font-size: 0.18rem;"
                            v-else
                          >{{scope.row.jobGroup}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="pointUser"
                        label="答复人"
                        min-width="400"
                      >
                        <template scope="scope">
                          <el-select
                            v-if="taskstatus==0"
                            class="h-tableInput"
                            v-model="scope.row.pointUser"
                            :v="scope.row.pointUser"
                            placeholder="请选择"
                            style="width: 100%"
                            @change="getNameCode(scope.row)"
                          >
                            <el-option
                              v-for="(item) in PointUser"
                              :key="item.id"
                              :label="item.pointUser"
                              :value="item.pointUser"
                            >
                            </el-option>
                          </el-select>
                          <span
                            style="color: #2785e7;font-size: 0.18rem;"
                            v-else
                          >{{scope.row.jobUsername}}--{{scope.row.jobUsercode}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="操作"
                        fixed="right"
                        width="100"
                        v-if="taskstatus==0"
                      >
                        <template slot-scope="scope">
                          <el-button
                            type="text"
                            class="h-tableLink h-btn"
                            @click="deleteThis(scope.$index)"
                          >
                            删除
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div
                      class="h-tableAdd"
                      v-if="taskstatus==0"
                    >
                      <a @click="add">新增一行</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="h-txtCenter h-mrt60">
          <el-button
            class="h-btn h-bBtn h-bgwhite"
            @click="backL"
          >返回</el-button>
          <el-button
            class="h-btn h-bBtn h-bgblueQ2"
            @click="savezy()"
            v-if="taskstatus==0"
          >确认提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ss from '../../../api/SystemService'
export default {
  data () {
    return {
      showhistory: false,
      j: {
        jobGroup: null,
        jobGroupPoint: null,
      },
      //部门及回复人
      PointUser: [],
      //链群
      JobGroup: [],
      //资源需求回复部门列表
      deptList: [],
      //用户列表
      optionsCustomer: [],
      //经销商列表
      optionsAgent: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      zy: {
        euName: null,
        euCode: null,
        endDate: null,
        areaCode: null,
        euType: 1,
        problemType: null,
        lianqun: null,
        dailyQuestion: null,
        taskid: null,
        aaa: 1
      },
      isSp: false,
      rules: {
        euType: [{ required: true, message: '请选择客户类型', trigger: 'blur' }],
        euName: [{ required: true, message: '请选择客户全称', trigger: 'blur' }],
        areaCode: [{ required: true, message: '请选择区域', trigger: 'change' }],
        dailyQuestion: [{ required: true, message: '请填写问题', trigger: 'blur' }],
        endDate: [{ required: true, message: '请选择答复截止时间', trigger: 'blur' }],
        lianqun: [{ required: true, message: '请选择链群', trigger: 'change' }],
        problemType: [{ required: true, message: '请选择问题类型', trigger: 'change' }],
      },
      ywid: '',
      taskstatus: 0,
    }
  },
  created () {
    this.ywid = this.$route.query.ywid || ''
    this.taskstatus = this.$route.query.taskstatus || ''
    this.zy.taskid = this.$route.query.taskid || ''
    this.query();
    this.selectJobGroup();
  },
  methods: {
    //带出用户编码
    getNameCode (value) {
      this.PointUser.forEach(elements => {
        console.log(elements)
        if (value.pointUser == elements.pointUser) {
          value.jobPoint = elements.jobPoint;
          value.jobUsername = elements.jobUsername;
          value.jobUsercode = elements.jobUsercode;
        }
      })
    },
    //用户名列表
    selectUser (value) {
      value.pointUser = null;
      this.j.jobGroup = value.jobGroup;
      this.j.jobGroupPoint = value.jobGroupPoint;
      ss.xietongguanli.selectAnsUser(this.j).then(rd => {
        this.PointUser = rd;
      });
    },
    // genzongLiuch () {
    //   this.showhistory = true;
    // },
    //部门列表
    selectJobGroup () {
      ss.xietongguanli.selectDeptPoint().then(rd => {
        this.JobGroup = rd;
      });
    },
    //删除该行项目产品信息
    deleteThis (index) {
      this.deptList.splice(index, 1);
    },
    add () {
      var list = {
        jobGroup: null,
        jobGroupPoint: null,
        pointUser: null,
        jobPoint: null,
        jobUsername: null,
        jobUsercode: null
      }
      this.deptList.push(list);
    },
    // 获取详情
    query () {
      ss.xietongguanli.showXTzyBH(this.ywid).then(res => {
        console.log(res)
        this.zy.euType = res.euType
        this.zy.euCode = res.euCode
        this.zy.euName = res.euName
        this.zy.areaCode = res.areaCode
        this.zy.lianqun = res.lianqun
        this.zy.problemType = res.problemType
        this.zy.endDate = res.endDate
        this.zy.dailyQuestion = res.dailyQuestion
        this.deptList = res.deptList
      });
    },
    getDate () {
      console.log(this.zy.endDate)
    },
    savezy () {
      this.$refs['zy'].validate((valid) => {
        if (valid) {
          if (this.deptList.length > 0) {
            var depflag = true;
            this.deptList.forEach(e => {
              if (e.jobGroup == null || e.pointUser == null) {
                depflag = false;
                this.$msg.msge("请完善资源需求部门信息再提交！");
                return false;
              }
            });
            if (depflag) {
              this.zy.deptList = this.deptList;
              this.$msg.confirm("确认提交该反馈问题?", () => {
                ss.noticeBoard.getJxsProblemPush({
                  ...this.zy,
                  id: this.ywid
                }).then(rd => {
                  this.$msg.msgs("操作成功");
                  this.$router.go(-1);
                });
              });
            }
          } else {
            this.$msg.msge("请完善反馈问题部门信息再提交！");
            return false;
          }
        } else {
          this.$msg.msge("请完善反馈问题后再提交！");
          return false;
        }
      });
    },
    backL () {
      this.$router.go(-1);
    },
  }
}
</script>
<style scoped>
.checkidBox {
  position: relative;
  overflow: hidden;
  border: 1px solid #ccc;
  padding: 5px 10px;
  margin-left: 20px;
  cursor: pointer;
  border-radius: 5px;
  height: 39px;
  line-height: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.checksBox:first-child {
  margin-left: 0;
}

.checkBoxs {
  height: 30px;
  line-height: 30px;
  padding: 5px;
  font-size: 12px;
}

.checkBoxs:first-child {
  margin-left: 0;
}

.checkidBox.active {
  border-color: #0e75e9;
  background: #0e75e9;
  color: #fff;
}

.inputlabel {
  position: absolute;
  left: -20px;
  top: 0;
  z-index: 3;
  padding-left: 7px !important;
  font-size: 14px !important;
  margin: 4px 0 0;
}
</style>

<style>
/* .h-formbLine1 .el-form-item__label{
	width: 21%!important;
}
.h-formbLine1 .el-form-item__content{
	width: 79%!important;
}
.h-formbLine1 .h-elformWrap-1 .el-form-item__label{
	width: 9.7%!important;
}
.h-formbLine1 .h-elformWrap-1 .el-form-item__content{
	width: 90.3%!important;
} */
.weekplandetail34 .h-formbLine .el-form-item__label {
  width: 34%;
  text-align: right;
}

.weekplandetail34 .h-formbLine .el-form-item__content {
  width: 66%;
}

.weekplandetail34 .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
  padding-right: 0.5rem;
}

.weekplandetail34 .h-formbLine .h-elformWrap-1 {
  width: 100%;
  padding-right: 0.5rem;
}

.weekplandetail34 .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 10.7%;
}

.weekplandetail34 .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 89.3%;
}

.h-formLine .el-checkbox__input {
  display: none;
}

.h-formLine .el-checkbox.is-bordered.is-checked {
  background: #2c83fd;
}

.h-formLine .el-checkbox-button.is-checked .el-checkbox-button__inner::after {
  content: '';
  background: url(../../../assets/images/checkBox.png);
  width: 10px;
  height: 10px;
}

.h-formLine .el-checkbox-button__inner {
  border: none;
  /* pazying: 9px 15px; */
}

.h-formLine .el-checkbox-button:first-child .el-checkbox-button__inner {
  border-radius: 0;
}

.h-formLine .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #2c83fd;
}

.h-formLine .el-checkbox-button:last-child .el-checkbox-button__inner {
  border-radius: 0;
}
.ljjtablepaddingsxuqiu .h-tableInput .el-input__inner {
  padding: 0.05rem 0.1rem;
}
.ljjtablepaddingsxuqiu .h-tableInput .el-input__icon {
  line-height: 0.25rem;
}
</style>
